// Formularz kontaktowy: wysyłka bez przeładowania strony (bez JS działa zwykły POST z przekierowaniem).
import {track} from "./analytics";

const ICON_OK = "<svg class=\"cc-icon\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M4.8 12.6 9.6 17.2 19.2 7.4\"/></svg>";
const ICON_ALERT = "<svg class=\"cc-icon\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><circle cx=\"12\" cy=\"12\" r=\"8.8\"/><path d=\"M12 7.4v5.4\"/><circle cx=\"12\" cy=\"16.3\" r=\"1.2\" fill=\"currentColor\" stroke=\"none\"/></svg>";

// Token wklejony w HTML bywa martwy, bo stronę wydaje CDN z cache'u starszego niż doba.
// Świeży bierzemy tuż przed wysyłką; POST-a nikt nie cache'uje.
async function freshNonce(action) {
    try {
        const response = await fetch(action, {
            method: "POST",
            body: new URLSearchParams({action: "cc_token"}),
            credentials: "same-origin",
            cache: "no-store",
            headers: {"X-Requested-With": "XMLHttpRequest", Accept: "application/json"}
        });
        const json = await response.json();
        return json?.data?.nonce || "";
    } catch {
        return "";
    }
}

export function initContactForms() {
    document.querySelectorAll("form[data-cc-contact]").forEach((form) => {
        const status = form.querySelector("[data-cc-status]");
        const button = form.querySelector("[type=\"submit\"]");
        // Ukryte pole name="action" przesłania właściwość form.action – ta zwraca wtedy sam element,
        // a nie adres, i żądanie leci pod „[object HTMLInputElement]”. Adres bierzemy z atrybutu.
        const endpoint = form.getAttribute("action");

        const setStatus = (type, message) => {
            if (!status) {
                return;
            }
            status.hidden = !message;
            status.className = `cc-form__status${type ? ` cc-form__status--${type}` : ""}`;
            status.innerHTML = message ? `${type === "ok" ? ICON_OK : ICON_ALERT}<span></span>` : "";
            if (message) {
                status.querySelector("span").textContent = message;
            }
        };

        form.addEventListener("submit", async (event) => {
            event.preventDefault();
            setStatus("", "");
            form.classList.add("is-sending");
            button?.setAttribute("disabled", "");

            try {
                const data = new FormData(form);
                const nonce = await freshNonce(endpoint);
                if (nonce) {
                    data.set("cc_nonce", nonce);
                }
                const response = await fetch(endpoint, {
                    method: "POST",
                    body: data,
                    credentials: "same-origin",
                    cache: "no-store",
                    headers: {"X-Requested-With": "XMLHttpRequest", Accept: "application/json"}
                });
                const json = await response.json().catch(() => ({}));
                const topic = form.querySelector("select[name='cc_topic']")?.value || "";
                if (json.success) {
                    track("formularz_wyslany", {temat: topic});
                    form.reset();
                    setStatus("ok", json.data?.message || "Dziękujemy!");
                    document.dispatchEvent(new CustomEvent("cc:celebrate", {detail: {el: button || form}}));
                } else {
                    track("formularz_blad", {powod: json.data?.message || "kod " + response.status, temat: topic});
                    // Własny komunikat dla odpowiedzi bez JSON-a (np. 404). Nie może brzmieć jak błąd poczty,
                    // bo wtedy nie widać różnicy między „list nie wyszedł” a „formularz nie doszedł do serwera”.
                    setStatus("error", json.data?.message
                        || `Formularz nie dotarł do serwera (błąd ${response.status}). Zadzwoń do nas – chętnie porozmawiamy.`);
                }
            } catch {
                setStatus("error", "Brak połączenia – spróbuj za chwilę albo zadzwoń do nas.");
            } finally {
                form.classList.remove("is-sending");
                button?.removeAttribute("disabled");
            }
        });
    });
}
